export default __webpack_public_path__ + "static/media/ImgGift02.9ce528ae.jpg";